export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/faces/kaci-baum-2-e06d84cb846db2a463ac3d904ac0c362.jpg";